export const actionTypes = {
    NEW_BRANCH: "NEW_BRANCH",
    LOADER: "LOADER",
    BRANCH_LIST: "BRANCH_LIST",
    ALL_BRANCH_LIST: "ALL_BRANCH_LIST",
    ALL_MEMBER_LIST: "ALL_MEMBER_LIST",
    ADMIN_LIST : "ADMIN_LIST",
    ALL_MASTER_MEMBER_LIST: "ALL_MASTER_MEMBER_LIST",
    ALL_MASTER_DATA: "ALL_MASTER_DATA",
    ALL_BRANCH_LIST_ADMIN : "ALL_BRANCH_LIST_ADMIN",
    ALL_FAMILY_MEMBER_LIST : "ALL_FAMILY_MEMBER_LIST",
    ALL_FAMILY_CORPORATE_LIST : 'ALL_FAMILY_CORPORATE_LIST',
    ALL_VFS_UK_DATA : 'ALL_VFS_UK_DATA',
    REFUND_REQUEST_LIST : 'REFUND_REQUEST_LIST',
    CREDIT_NOTE_LIST : 'CREDIT_NOTE_LIST',
    ALL_COUNTRY_LIST:'ALL_COUNTRY_LIST',
    ALL_ZONE_LIST:'ALL_ZONE_LIST',
    ALL_REGION_LIST:'ALL_REGION_LIST',
    PAYMENT_FAILED_LIST : 'PAYMENT_FAILED_LIST',
    REFUND_PROCESS_STEPS:'REFUND_PROCESS_STEPS',
    BLS_MEMBER_LIST : 'BLS_MEMBER_LIST',
    BLS_CORPORATE_LIST : 'BLS_CORPORATE_LIST',
    TEAM_MEMBER_LIST : 'TEAM_MEMBER_LIST',
    ADMIN_TEAM_MEMBER_LIST : 'ADMIN_TEAM_MEMBER_LIST',
    ADMIN_TEAM_PERMISSION_LIST : 'ADMIN_TEAM_PERMISSION_LIST'
};

const INITIAL_STATE = {
    NewBranch: [],
    corporateloader: false,
    BranchList: [],
    AllBranchList: [],
    MemberList: [],
    AdminList: [],
    AllMasterMemberList: [],
    AllMasterData: [],
    AllBranchListAdmin: [],
    AllFamilyMemberList : [],
    AllFamilyCorporateList : [],
    AllVfsUkData : [],
    RefundRequestList : [],
    CreditNoteList : [],
    AllCountryList : [],
    AllZoneList : [],
    AllRegionList : [],
    PaymentFailedList : [],
    RefundProcessSteps : {},
    BlsMemberList: [],
    BlsCorporateList: [],
    TeamMemberList: [],
    AdminTeamMemberList: [],
    AdminTeamPermissionList: []
};

const MasterAdminReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.LOADER:
            return {
                ...state,
                corporateloader: action.corporateloader,
            };

        case actionTypes.NEW_BRANCH:
            return {
                ...state,
                NewBranch: action.NewBranch,
                corporateloader: action.corporateloader,
            };
        case actionTypes.BRANCH_LIST:
            return {
                ...state,
                BranchList: action.BranchList,
            };
        case actionTypes.ALL_BRANCH_LIST:
            return {
                ...state,
                AllBranchList: action.AllBranchList,
            };
        case actionTypes.ALL_MEMBER_LIST:
            return {
                ...state,
                MemberList: action.MemberList,
            };
        case actionTypes.ADMIN_LIST:
            return {
                ...state,
                AdminList: action.AdminList,
            };
        case actionTypes.ALL_MASTER_MEMBER_LIST:
            return {
                ...state,
                AllMasterMemberList: action.AllMasterMemberList,
            };
        case actionTypes.ALL_MASTER_DATA:
            return {
                ...state,
                AllMasterData: action.AllMasterData,
            };
        case actionTypes.ALL_BRANCH_LIST_ADMIN:
            return {
                ...state,
                AllBranchListAdmin: action.AllBranchListAdmin,
            };
        case actionTypes.ALL_FAMILY_MEMBER_LIST:
            return {
                ...state,
                AllFamilyMemberList: action.AllFamilyMemberList,
            };
        case actionTypes.ALL_FAMILY_CORPORATE_LIST:
            return {
                ...state,
                AllFamilyCorporateList: action.AllFamilyCorporateList,
            };
        case actionTypes.ALL_VFS_UK_DATA:
              return {
                ...state,
                AllVfsUkData: action.AllVfsUkData,
            };
        case actionTypes.REFUND_REQUEST_LIST:
              return {
                ...state,
                RefundRequestList: action.RefundRequestList,
            };
        case actionTypes.CREDIT_NOTE_LIST:
              return {
                ...state,
                CreditNoteList: action.CreditNoteList,
            };
        case actionTypes.ALL_COUNTRY_LIST:
            return{
                ...state,
                AllCountryList:action.AllCountryList
            };
        case actionTypes.ALL_ZONE_LIST  :
            return{
                ...state,
                AllZoneList :action.AllZoneList
            };
        case actionTypes.ALL_REGION_LIST:
            return{
                ...state,
                AllRegionList:action.AllRegionList
            };
        case actionTypes.PAYMENT_FAILED_LIST:
            return{
                ...state,
                PaymentFailedList:action.PaymentFailedList
            };

        case actionTypes.REFUND_PROCESS_STEPS:
            return{
                ...state,
                RefundProcessSteps:action.RefundProcessSteps
            };
        case actionTypes.BLS_MEMBER_LIST:
            return{
                ...state,
                BlsMemberList:action.BlsMemberList
            };
        case actionTypes.BLS_CORPORATE_LIST:
            return{
                ...state,
                BlsCorporateList:action.BlsCorporateList
            };
        case actionTypes.TEAM_MEMBER_LIST:
            return{
                ...state,
                TeamMemberList:action.TeamMemberList
            };
        case actionTypes.ADMIN_TEAM_MEMBER_LIST:
            return{
                ...state,
                AdminTeamMemberList:action.AdminTeamMemberList
            };
        case actionTypes.ADMIN_TEAM_PERMISSION_LIST:
            return{
                ...state,
                AdminTeamPermissionList:action.AdminTeamPermissionList
            };
        default:
            return state;
    }
};

export default MasterAdminReducer;
